import onGetDashboardCounters from './onGetDashboardCounters';

export default {
  onGetDashboardCounters,
};
